import React, { createContext, useContext, useState } from 'react';

const SettingsModalContext = createContext();

// Settings became a modal instead of the /settings page (docs/DECISIONS.md,
// "Settings modal" decision) - it's triggered from several unrelated
// places (StudentSidebar's Settings nav item, and the profile dropdowns in
// AppHeader.jsx, CurriculumMenuPage.jsx, Home.jsx) that don't share a
// common ancestor below App.js, so open/close state lives here rather than
// being owned by any one of those components.
export function SettingsModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openSettings = () => setIsOpen(true);
  const closeSettings = () => setIsOpen(false);

  return (
    <SettingsModalContext.Provider value={{ isOpen, openSettings, closeSettings }}>
      {children}
    </SettingsModalContext.Provider>
  );
}

export function useSettingsModal() {
  const context = useContext(SettingsModalContext);
  if (!context) {
    throw new Error('useSettingsModal must be used within SettingsModalProvider');
  }
  return context;
}
